/* eslint-disable node/no-unsupported-features/es-syntax */
import { PROMOCODES_ROUTE_NAMES } from "@/shared";

export const PROMOCODES_ROUTES = [
    {
        name: PROMOCODES_ROUTE_NAMES.LIST,
        path: "/promocodes",
        meta: {
            title: "Промокоды",
        },
        component: () => import("../ui/PromocodesList.vue"),
    },
    {
        name: PROMOCODES_ROUTE_NAMES.CREATE,
        path: "/promocodes/add",
        meta: {
            title: "Новый промокод",
        },
        component: () => import("../ui/PromocodesEdit.vue"),
    },
    {
        name: PROMOCODES_ROUTE_NAMES.EDIT,
        path: "/promocodes/:id",
        meta: {
            title: "Редактирование промокода",
        },
        component: () => import("../ui/PromocodesEdit.vue"),
        props: true,
    },
];
